import React, { useState, useEffect } from 'react';
import { sanitizePrice } from '@this/src/util/price/price.util';

interface Props {
  initialValue?: number;
  className?: string;
  onChange: (value: number) => void;
}

const PriceField: React.FC<Props> = ({ initialValue, className, onChange }) => {
  const [value, setValue] = useState<string>((initialValue || 0).toString());
  const [viewValue, setViewValue] = useState<string>(
    (initialValue || 0).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
  );

  useEffect(() => {
    const initValue = (initialValue || 0).toString();
    setValue(initValue);
    setViewValue(initValue.replace(/\B(?=(\d{3})+(?!\d))/g, ','));
  }, [initialValue]);

  const handleChange = (inputValue: string) => {
    const changeValue = (parseInt(inputValue.replace(/,/g, ''), 10) || 0).toString();
    setValue(changeValue);
    setViewValue(changeValue.replace(/\B(?=(\d{3})+(?!\d))/g, ','));
  };

  const handleBlur = () => {
    const newPrice = sanitizePrice(value) || 0;
    const newPriceStr = newPrice.toString();
    setValue(newPriceStr);
    onChange(newPrice);
  };

  return (
    <input
      type="text"
      className={className}
      value={viewValue}
      onChange={e => handleChange(e.target.value)}
      onBlur={handleBlur}
    />
  );
};

export default PriceField;
